import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  key_word: string // 搜索关键词
  group_id: number // 分组id
  page: number // 页码
  limit: number // 每页数量
  sort?: string // 排序字段
  asc?: boolean // 顺序
  login_status?: number // 登录状态
}

export interface ClientInfo {
  computer_name: string // 计算机名
  /** 所属分组 */
  group_name?: string
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  soft_count: number // 软件数量
  device_id: string // 终端id
  /** 登录状态 */
  login_status?: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}

export interface ResponseData {
  list: ClientInfo[] // 终端软件信息
  total: number // 总数
}

@Injectable()
export class ClientViewService {
  constructor (private http: Http) {}

  @ParamsClean()
  @InvokeThrottle()
  getSoftmgrTerminalStat (data: QueryParams) {
    return this.http.post<ResponseData>('/softmgr/terminal-stat', data)
  }

  download (type: 0|1, options: QueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/terminal-stat/export', params, moduleName)
  }
}
